var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgXlsxDownload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "13px",
    height: "17px",
    viewBox: "0 0 13 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "scaricadati",
    transform: "translate(-14.000000, -4.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(14.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-5",
    fill: "#1B7343",
    points: "0 0 9.05322266 0 10.5510254 2.2565918 13 4.16601562 13 17 0 17"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "X",
    fill: "#FFFFFF",
    points: "3.23925781 13 5.55371094 9.44042969 3.34179688 5.7734375 5.09472656 5.7734375 6.56445312 8.20507812 8.15625 5.7734375 9.37207031 5.7734375 7.15527344 9.18164062 9.45019531 13 7.70214844 13 6.13476562 10.4169922 4.45507812 13"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-6",
    fill: "#49986D",
    points: "9 0 11 2 13 4 9 4"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXlsxDownload);
export default __webpack_public_path__ + "static/media/xlsxDownload.3d7eeb8aad595b4f5b8d4b45555870f4.svg";
export { ForwardRef as ReactComponent };